module.exports = __webpack_public_path__ + "img/whatsapp-white.1d5e74f7.svg";